import React, { useEffect } from "react";
import { Helmet } from "react-helmet-async";

import Hero from "../components/Hero";
import BrandSlider from "../components/BrandSlider";
import Services from "../components/Services";
import WhyChoose from "../components/Whychoose";
import Timeline from "../components/Timeline";
import Reviews from "../components/Reviews";

import "./Home.css";

const Home = () => {
  useEffect(() => {
    document.body.classList.add("home-snap");
    return () => document.body.classList.remove("home-snap");
  }, []);

  return (
    <>
      {/* ================= SEO ================= */}
      <Helmet>
        <title>Servizy | Mobile  Repair Service at Home</title>

        <meta
          name="description"
          content="Servizy provides fast and reliable mobile  repair services at your doorstep with expert technicians and warranty."
        />

        <meta
          name="keywords"
          content="mobile repair,  doorstep repair, phone repair India, Servizy"
        />

        <link rel="canonical" href="https://servizyweb.netlify.app/" />

        {/* Open Graph */}
        <meta property="og:title" content="Servizy Repair Service" />
        <meta
          property="og:description"
          content="Doorstep mobile  repair service with warranty."
        />
        <meta
          property="og:image"
          content="https://servizyweb.netlify.app/s.png"
        />
        <meta
          property="og:url"
          content="https://servizyweb.netlify.app/"
        />
        <meta property="og:type" content="website" />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Servizy Repair Service" />
        <meta
          name="twitter:description"
          content="Best repair service at your doorstep"
        />
        <meta
          name="twitter:image"
          content="https://servizyweb.netlify.app/s.png"
        />
      </Helmet>
<div style={{display:"none"}}>
mobile repair Bangalore, phone repair Bangalore,
doorstep mobile repair Bangalore, screen replacement Bangalore,
battery replacement Bangalore
</div>
      {/* ================= PAGE ================= */}
      <main className="home-page">
        <Hero />
        <BrandSlider />
        <Services />
        <WhyChoose />
        <Timeline />
        <Reviews />
      </main>
    </>
  );
};

export default Home;